export default "__VITE_ASSET__D6gGj9Qb__"